import { render } from "./OpenRequestConfirmation.vue?vue&type=template&id=d1c47284&scoped=true"
import script from "./OpenRequestConfirmation.vue?vue&type=script&lang=js"
export * from "./OpenRequestConfirmation.vue?vue&type=script&lang=js"

import "./OpenRequestConfirmation.vue?vue&type=style&index=0&id=d1c47284&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d1c47284"]])

export default __exports__